import { ArrowRight } from "lucide-react";
import { AlluLogo } from "@/components/parceiros-v2/AlluLogo";

const NAV_LINKS = [
  { href: "#para-quem-e", label: "Para quem é" },
  { href: "#diferenciais", label: "Diferenciais" },
  { href: "#como-funciona", label: "Como funciona" },
  { href: "#depoimentos", label: "Depoimentos" },
];

export const AssessoresHeader = () => {
  return (
    <div className="sticky top-3 sm:top-4 z-50 w-full px-3 sm:px-6">
      <header className="container-wide mx-auto flex items-center justify-between gap-4 rounded-2xl bg-[#FAF8F5]/95 backdrop-blur px-4 sm:px-5 py-2.5 shadow-[0_2px_20px_rgba(50,63,79,0.08)] ring-1 ring-black/5">
        <a href="/assessores" aria-label="Allu" className="block shrink-0">
          <AlluLogo variant="dark" className="h-8 sm:h-9 w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-zinc-600 hover:text-[#323F4F] transition-colors"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <a
          href="#form"
          className="inline-flex items-center justify-center gap-1.5 rounded-2xl bg-[#2E694D] hover:bg-[#255A41] text-[#FAFAFA] text-xs sm:text-sm font-medium px-4 sm:px-[18px] py-3.5 transition-colors shrink-0"
        >
          Seja parceiro
          <ArrowRight className="w-3.5 h-3.5" />
        </a>
      </header>
    </div>
  );
};
